import * as React from 'react';

interface SVGProps {
	className?: string;
}

const PasswordLockIcon: React.FC<SVGProps> = ({ className }) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='90'
		height='90'
		fill='none'
		viewBox='0 0 90 90'
		className={className}>
		<g clipPath='url(#clip0_840_8068)'>
			<path
				fill='#B5D5EA'
				fillRule='evenodd'
				d='M62.25 58.5H88.5a3.75 3.75 0 0 1 3.75 3.75v22.496a3.75 3.75 0 0 1-3.75 3.75H62.25a3.75 3.75 0 0 1-3.75-3.75V62.25a3.75 3.75 0 0 1 3.75-3.75m17.813 15.233a4.688 4.688 0 1 1-9.376 0 4.688 4.688 0 0 1 9.376 0'
				clipRule='evenodd'></path>
			<path
				stroke='#B5D5EA'
				strokeWidth='3.75'
				d='M42.938 42.375a.937.937 0 1 1 0-1.875M42.938 42.375a.937.937 0 1 0 0-1.875M24.938 42.375a.937.937 0 1 1 0-1.875M24.938 42.375a.937.937 0 1 0 0-1.875'></path>
			<path
				stroke='#0973BA'
				strokeLinecap='round'
				strokeLinejoin='round'
				strokeWidth='3.75'
				d='M84.375 58.128h-26.25a3.75 3.75 0 0 0-3.75 3.75v22.496a3.75 3.75 0 0 0 3.75 3.75h26.25a3.75 3.75 0 0 0 3.75-3.75V61.878a3.75 3.75 0 0 0-3.75-3.75'></path>
			<path
				stroke='#0973BA'
				strokeLinecap='round'
				strokeLinejoin='round'
				strokeWidth='3.75'
				d='M71.25 78.049a4.687 4.687 0 1 0 0-9.375 4.687 4.687 0 0 0 0 9.375M80.625 52.5a9.377 9.377 0 0 0-16.004-6.63 9.38 9.38 0 0 0-2.746 6.63v5.625h18.75z'></path>
			<path
				stroke='#0973BA'
				strokeLinecap='round'
				strokeLinejoin='round'
				strokeWidth='3.75'
				d='M46.875 58.125h-37.5a7.5 7.5 0 0 1-7.5-7.5v-18.75a7.5 7.5 0 0 1 7.5-7.5h71.25a7.5 7.5 0 0 1 7.5 7.5v18.75'></path>
			<path
				stroke='#0973BA'
				strokeWidth='3.75'
				d='M22.5 42.188a.937.937 0 1 1 0-1.876M22.5 42.188a.937.937 0 1 0 0-1.876M40.313 42.188a.937.937 0 1 1 0-1.876M40.313 42.188a.937.937 0 1 0 0-1.876'></path>
		</g>
		<defs>
			<clipPath id='clip0_840_8068'>
				<path
					fill='#fff'
					d='M0 0h90v90H0z'></path>
			</clipPath>
		</defs>
	</svg>
);

export default PasswordLockIcon;
